import React from 'react';
import {
  NavbarComponent,
  NavbarComponentBasic,
  CustomisedNavbar,
} from '../components/Navbars';

import { useDashboardTopBar } from '../hooks';
import { useSelector } from 'react-redux';
import type { RootState } from '../../store';
import ErrorBoundary from '../components/Error/ErrorBoundary';
import { useLocation } from 'react-router-dom';

interface Ai2LayoutProps {
  children: React.ReactNode;
}
export const Ai2Layout = ({ children }: Ai2LayoutProps) => {
  const { showCustomisedNavbar } = useDashboardTopBar();
  const { selectedTenancy } = useSelector(
    (state: RootState) => state.clinicianProfile,
  );

  if (!selectedTenancy) {
    return <></>;
  }

  return (
    <>
      {showCustomisedNavbar ? <CustomisedNavbar /> : <NavbarComponent />}
      {children}
    </>
  );
};

export const CareMapprLayoutBasic = ({
  children,
  noRedirect,
}: {
  children: React.ReactNode;
  noRedirect?: boolean;
}) => {
  const location = useLocation();
  return (
    <>
      <NavbarComponentBasic />
      <ErrorBoundary
        key={`${location.pathname}${location.search}`}
        redirectTo={noRedirect ? undefined : '/login'}
      >
        {children}
      </ErrorBoundary>
    </>
  );
};
